import { AuthenticationService } from '@/services/AuthenticationService.ts';
import { router, ROUTES } from '@/router.ts';
import { useAuthStore } from '@/stores/AuthStore.ts';
import { WebSocketService } from '@/ws/WebSocketService.ts';
import { useClientStore } from '@/stores/ClientStore.ts';

export const logOutAction = async () => {
    AuthenticationService.instance.clearTokenData();

    const authStore = useAuthStore();
    authStore.isLoggedIn = false;

    WebSocketService.instance.disconnect();

    useClientStore().$patch((state) => {
        state.activeSessionId = undefined;
        state.activeProfileId = undefined;
        state.screenCapturesBySession = {};
        state.screenCaptureRevisions = {};
    });
    await router.push({ name: ROUTES.authLogin });
};
